import { FunctionComponent, useEffect, useState } from 'react';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { Document, pdfjs, Page } from 'react-pdf';

// components
import FilePreview from 'components/filePreview/filePreview';
import { onGetUserAssignmentDocument } from '../services/documentsService';
import NotificationService from 'core/services/notification';
import { File } from '../models/companyDocuments';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import NoData from 'components/noData/noData';
import { getViewerWidth } from 'utils/fileViewerWidth';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

const UserAssignmentComponent: FunctionComponent = () => {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState(true);
	const [document, setDocument] = useState<File>();
	const [numOfPages, setNumOfPages] = useState<number>(0);
	const [containerWidth, setContainerWidth] = useState<number>(getViewerWidth());

	useEffect(() => {
		getDocumentHandler();

		const handleResize = () => {
			setContainerWidth(getViewerWidth());
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const getDocumentHandler = async () => {
		try {
			setIsLoading(true);

			const response = await onGetUserAssignmentDocument();
			if (response?.userAssignmentForm?.download_link) setDocument(response.userAssignmentForm);

			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.FETCH_ERROR'));
		}
	};

	const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
		setNumOfPages(numPages);
	};

	return (
		<Card>
			{isLoading ? (
				<LoadingComponent />
			) : document ? (
				<>
					<div style={{ border: '1px solid #ddd' }}>
						<Document file={document.download_link} onLoadSuccess={onDocumentLoadSuccess} className="agreementPdf" loading={<></>}>
							{Array.from({ length: numOfPages }, (_, i) => (
								<Page loading={<></>} pageNumber={i + 1} scale={1} width={containerWidth} key={i} />
							))}
						</Document>
					</div>

					<div className="mt-3 m-auto" style={{ width: getViewerWidth() }}>
						<FilePreview
							name={document!.title}
							data={`${document!.last_modified_date} | ${document?.size_in_kilobyte?.toFixed(0)} KB`}
							downloadLink={document!.download_link}
						/>
					</div>
				</>
			) : (
				<NoData />
			)}
		</Card>
	);
};

export default UserAssignmentComponent;
